import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  CONFIRM_GENERIC_ERROR_BANK,
  CONFIRM_GENERIC_ERROR_VALID_BANK,
  ORIGEN_VALIDAR_API_SANTANDER,
  ORIGEN_VALIDAR_CUENTAS_DIGITALES,
  SELECTED_BANK,
  TYPES_BANKS,
  TYPES_BANKS_ACCOUNTS,
} from "@constants/cambio-via-pago-properties.constants";
import { STORAGE_FORM_VIA_PAGO } from "@constants/tramite-pension-constant";
import { INICIO, ROUTING_TRAMITE_PENSION } from "@constants/url.constant";
import { ISelectedBank } from "@interfaces/seleted-bank.interface";
import { ITiposCuentasBancariasTramitePension } from "@interfaces/tipos-cuentas-bancarias.interface";
import { ValidarRequest } from "@interfaces/validar-cuentas.interface";
import { ModalOptions } from "@ionic/angular";
import { GtmService } from "@services/gtm/gtm.service";
import { ModalService } from "@services/modal/modal.service";
import { StorageService } from "@services/storage/storage.service";
import { Util } from "@shared/common/utils/util";
import { GenericErrorOps } from "@shared/components/generic-error/interfaces/generic-error-ops.interface";
import { ModalValidarCuentasComponent } from "@shared/components/modal-validar-cuentas/modal-validar-cuentas.component";
import { Subscription, firstValueFrom } from "rxjs";
import { CambioViaPagoPensionService } from "src/app/cambio-via-pago-pension/core/services/cambio-via-pago-pension.service";
import { TramitePensionService } from "../../services/tramite-pension.service";
import { TramiteStepperService } from "../../services/tramite-stepper.service";


@Component({
  selector: "app-via-pago",
  templateUrl: "./via-pago.component.html",
  styleUrls: ["./via-pago.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ViaPagoComponent implements OnInit, OnDestroy {
  loading: boolean = false;
  isLoading: boolean = false;
  tipoCuentas: ITiposCuentasBancariasTramitePension[] = [];
  token: string = "";
  labelBanco: string = 'Selecciona un banco';
  labelCheckLegal: string = 'Declaro que la cuenta ingresada está a mi nombre y es unipersonal';
  numericPattern: RegExp = /^\d$/;

  isLoadData: boolean = false;

  form: FormGroup;
  cuentaBancaria: any;
  opcionesModal: ModalOptions;
  excepcionServicio: boolean = false;
  bancoSeleccionado: number = 0;
  sub: Subscription = new Subscription();

  isError: boolean = false;
  errorOps: GenericErrorOps;
  attempt: boolean = false;
  nAttempts: number = 0;
  selectedIndex = -1;
  selectTiposBancos: boolean = false;
  labelViaPago: string = 'Selecciona una vía de pago';

  public viaPagoOptions: { value: any, name: string }[] = [];
  public bancosOptions: { value: any, name: string }[] = [];

  constructor(
    private readonly storageService: StorageService,
    private readonly stepsService: TramiteStepperService,
    private readonly _fb: FormBuilder,
    private readonly tramitePensionService: TramitePensionService,
    private readonly _modalService: ModalService,
    private readonly _router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly util: Util,
    private readonly cambioViaPagoPensionService: CambioViaPagoPensionService,
    private readonly gtmService: GtmService,
    
  ) {
    stepsService.setStepCurrent(4);
    this.crearFormulario();
  }

  async ngOnInit() {
    this.loading = true;
    this.token = await this.util.getIdToken();

    await this.loadData();
    this.configurarValueChanges();
  }

  private configurarValueChanges(): void {
    this.form.get('numeroCuenta')?.valueChanges.subscribe(() => {
      if (!this.isCheckLegal && this.form.get("checkLegal")?.value) {
        this.form.patchValue({ checkLegal: false });
      }
    });

    this.form.get('codigoViaPago')?.valueChanges.subscribe((viaPagoId) => {
      const viaPago = this.viaPagoOptions.find(v => v.value === viaPagoId);
      if (viaPago) {
        void this.seleccionTipoPago(viaPago);
      }
    });

    this.form.get('codigoInstitucionFinanciera')?.valueChanges.subscribe((bancoId) => {
      const banco = this.bancosOptions.find(b => b.value === bancoId);
      if (banco) {
        void this.seleccionBanco(banco);
      }
    });
  }

  async loadData() {
    const savedState = await this.storageService.get(STORAGE_FORM_VIA_PAGO);
    await this.getDatosDeTransferencia();
    if (savedState && this.isError === false) {
      if (savedState.codigoViaPago === 'D') {
        this.selectTiposBancos = true;
        this.removeTipoCuentaRUT(savedState.codigoInstitucionFinanciera);
        this.seleccionarCuenta(savedState.tipoCuenta);
      }
      this.form.patchValue(savedState);
    }
  }

  async getDatosDeTransferencia(): Promise<void> {
    try {
      const response = await this.tramitePensionService.obtenerViaDePagosPromise();
      this.tipoCuentas = response.cuentas.map((cuenta) => ({
        nameTipoCuenta: cuenta.name,
        idTipoCuenta: cuenta.id,
        seleccionado: true,
      }));

      this.viaPagoOptions = response.metodoPago.map(item => ({
        value: item.id,
        name: item.name
      }));

      this.bancosOptions = response.bancos.map(item => ({
        value: item.idBanco,
        name: item.nameBanco
      }));
      this.formatBanks(this.bancosOptions)

      this.isError = false;
      this.attempt = false;
      this.storageService.set(TYPES_BANKS, this.bancosOptions);
      this.storageService.set(TYPES_BANKS_ACCOUNTS, this.tipoCuentas);
      this.loading = false;
    } catch {
      this.isLoadData = true;
      this.errorOps = CONFIRM_GENERIC_ERROR_BANK;
      this.errorImplement();
    }
  }

  formatBanks(banksArray: { value: any, name: string }[]) {
    banksArray = this.sortTypessBanks(banksArray)
    banksArray.forEach(bank => {
      bank.name = bank.name.includes('Banco') ? bank.name : `Banco ${bank.name}`
    })
  }

  sortTypessBanks(typeBanks: { value: any, name: string }[]) {
    return typeBanks.sort((a, b) => a.name.trim().localeCompare(b.name.trim()));;
  }

  private crearFormulario() {
    this.form = this._fb.group({
      codigoViaPago: ["", Validators.required],
      codigoInstitucionFinanciera: ["", Validators.required],
      tipoCuenta: ["", Validators.required],
      numeroCuenta: [
        "",
        [
          Validators.required,
          Validators.maxLength(18),
          Validators.pattern("^[0-9]*$"),
        ],
      ],
      checkLegal: [false, Validators.required],
      descripcionBanco: [""],
      descripcionTipoCuenta: [""],
    });
  }

  async seleccionBanco(banco: { value: any, name: string }) {
    this.tipoCuentas = await this.storageService.get(TYPES_BANKS_ACCOUNTS);
    this.removeTipoCuentaRUT(banco.value);

    this.form.patchValue({
      tipoCuenta: "",
      numeroCuenta: "",
      checkLegal: false,
      descripcionTipoCuenta: "",
      descripcionBanco: banco.name
    });

    this.tipoCuentas.forEach(cuenta => cuenta.seleccionado = true);
  }

  private removeTipoCuentaRUT(val: any) {
    const bancoEstado = 12; // Banco Estado ID
    const tipoCuentaRUT = 'R';
    if (val != bancoEstado)
      this.tipoCuentas = this.tipoCuentas.filter(
        (elemento) => elemento.idTipoCuenta !== tipoCuentaRUT
      );

    if (this.isCuentaRut) void this.getRutAfiliado();
  }

  seleccionarCuenta(id: string) {
    this.tipoCuentas.forEach((opcion) => (opcion.seleccionado = true));

    const cuentaEncontrada = this.tipoCuentas.find((x) => x.idTipoCuenta == id);
    if (cuentaEncontrada) {
      cuentaEncontrada.seleccionado = false;

      this.form.get("tipoCuenta")?.setValue(id);

      this.form.patchValue({
        numeroCuenta: "",
        checkLegal: false,
        descripcionTipoCuenta: cuentaEncontrada.nameTipoCuenta
      });

      if (this.isCuentaRut) void this.getRutAfiliado();
    }
  }

  async getRutAfiliado() {
    try {
      const rut = await this.tramitePensionService.uid();
      const cuentaRut = rut.slice(0, -1);
      this.form.get("numeroCuenta")?.setValue(cuentaRut);
    } catch {
      const rut = await this.tramitePensionService.uid();
      const cuentaRut = rut.slice(0, -1);
      this.form.get("numeroCuenta")?.setValue(cuentaRut);
    }
  }

  enterCheckLegal() {
    const check = this.form.get('checkLegal')?.value;
    if (check) this.form.get('checkLegal')?.setValue(false)
    else this.form.get('checkLegal')?.setValue(true)
  }

  async continue() {

    if (this.attempt && this.form.invalid) {
      return;
    }

    this.isLoading = true;

    const { codigoInstitucionFinanciera, numeroCuenta, tipoCuenta, descripcionTipoCuenta, descripcionBanco, codigoViaPago } = this.form.value;
    const viaPagoSeleccionada = this.viaPagoOptions.find(
      v => v.value === codigoViaPago
    );
    const descripcionViaPago = viaPagoSeleccionada?.name ?? '';
    const selectBank = { codigoViaPago: codigoViaPago, codigoInstitucionFinanciera: String(codigoInstitucionFinanciera), numeroCuenta, tipoCuenta: String(tipoCuenta), descripcionTipoCuenta, descripcionBanco, descripcionViaPago } as ISelectedBank
    this.storageService.set(STORAGE_FORM_VIA_PAGO, this.form.value);
    const viaPago = this.form.get("codigoViaPago")?.value.toString()
    if (viaPago !== "" && viaPago !== "D") {
      this.storageService.set(SELECTED_BANK, selectBank);
      this.gtmService.trackClick('button', 'Continuar', 'boton_principal', '/pensions/tramite-pensiones/solicitud/carga-documentos');
      this._router.navigate(
        [
          `../${ROUTING_TRAMITE_PENSION.CARGA_DOCUMENTOS}`,
        ],
        {
          relativeTo: this.activatedRoute,
        }
      );
      this.isLoading = false;
    }
    else
      try {
        const requestValidaCuentasDigitales: ValidarRequest = {
          codigoInstitucionFinanciera,
          numeroCuenta,
        };

        const responseCuentasDigitales = await this.tramitePensionService
          .validarCuentasDigitales(requestValidaCuentasDigitales, this.token)
          .toPromise();

        if (responseCuentasDigitales?.digital) {
          await this.abrirModalValidarCuentas(ORIGEN_VALIDAR_CUENTAS_DIGITALES);
          this.isLoading = false;
          return;
        }

        const requestValidaCuentas: ValidarRequest = {
          codigoInstitucionFinanciera,
          numeroCuenta,
        };

        const responseValidaCuentas = await firstValueFrom(
          this.cambioViaPagoPensionService.validarCuentasBancarias(
            requestValidaCuentas,
            this.token
          )
        );

        const requiereValidacionSantander =
          responseValidaCuentas.switchHabilitarApiSantander &&
          responseValidaCuentas.estadoValidacionAPI === "R";

        if (requiereValidacionSantander) {
          this.excepcionServicio = false;
          await this.abrirModalValidarCuentas(ORIGEN_VALIDAR_API_SANTANDER, selectBank);
          this.isLoading = false;
          return;
        }

        this.storageService.set(SELECTED_BANK, selectBank);
        this._router.navigate([`../${ROUTING_TRAMITE_PENSION.CARGA_DOCUMENTOS}`], {
          relativeTo: this.activatedRoute,
        });
        this.isLoading = false;

      } catch {
        this.isLoadData = false;
        this.errorOps = CONFIRM_GENERIC_ERROR_VALID_BANK;
        this.errorImplement();
      }
  }
  errorImplement() {
    if (this.nAttempts === 3) {
      this.attempt = false;
      this.isError = false;
      this.nAttempts = 0;
      this._router.navigate([
        ROUTING_TRAMITE_PENSION.BASE_URL
      ]);
    }
    this.loading = false;
    this.isLoading = false;
    this.isError = true;
    this.attempt = false;
  }

  async abrirModalValidarCuentas(origen: string, selectBank?: ISelectedBank): Promise<boolean> {
    const opcionesModal: ModalOptions = {
      component: ModalValidarCuentasComponent,
      backdropDismiss: true,
      cssClass: "validarCuentas__modal",
      componentProps: {
        origenValidacion: origen,
      },

    };

    const modal = await this._modalService.openModal(opcionesModal);
    const { data } = await modal.onDidDismiss();

    if (!data) {
      return false;
    }

    switch (data.origen) {
      case ORIGEN_VALIDAR_CUENTAS_DIGITALES:
        this.resetForm();
        return true;

      case ORIGEN_VALIDAR_API_SANTANDER:
        if (data.botonIngresar) {
          this.storageService.set(SELECTED_BANK, selectBank);
          this._router.navigate(
            [`../${ROUTING_TRAMITE_PENSION.CARGA_DOCUMENTOS}`],
            {
              relativeTo: this.activatedRoute,
            }
          );
        }
        else {
          this.isError = false;
          this.resetForm();
        }
        return true;

      default:
        return false;
    }

  }
  resetForm() {
    this.form.patchValue({
      codigoInstitucionFinanciera: "",
      tipoCuenta: "",
      numeroCuenta: "",
      checkLegal: false
    });
    void this.storageService.remove(STORAGE_FORM_VIA_PAGO);
    this.tipoCuentas.forEach(cuenta => cuenta.seleccionado = true);

  }

  async onRetryEvent() {
    this.attempt = true;
    this.nAttempts++;
    if (this.nAttempts <= 3 && this.isLoadData) {
      await this.loadData();
    } else if (this.nAttempts <= 3 && !this.isLoadData) {
      await this.continue();
    }
  }

  onGoToEvent() {
    this._router.navigate([INICIO]);
  }

  get isInvalidForm(): boolean {
    const codigoViaPago = this.form.get("codigoViaPago")?.value.toString()
    if (codigoViaPago !== "" && codigoViaPago !== "D") {
      return false;
    }
    return this.form.invalid || this.form.getRawValue().checkLegal === false;
  }

  get isCuentaRut(): boolean {
    return (
      this.form.get("codigoInstitucionFinanciera")?.value === 12 &&
      this.form.get("tipoCuenta")?.value === 'R'
    );
  }

  get isCheckLegal(): boolean {
    return (
      this.form.get("codigoInstitucionFinanciera")?.value !== "" &&
      this.form.get("tipoCuenta")?.value !== "" &&
      this.form.get("numeroCuenta")?.value !== ""
    );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  goBack() {
    this._router.navigate([`../${ROUTING_TRAMITE_PENSION.ANTECEDENTES_PENSION}`], {
      relativeTo: this.activatedRoute,
    });
  }

  async seleccionTipoPago(tipoViaPago: { value: any, name: string }) {
    this.selectTiposBancos = tipoViaPago.value === "D";

    if (!this.selectTiposBancos) {
      this.form.patchValue({
        tipoCuenta: "",
        codigoInstitucionFinanciera: "",
        numeroCuenta: "",
        checkLegal: false,
        descripcionTipoCuenta: "",
        descripcionBanco: ""
      });
      this.tipoCuentas.forEach(cuenta => cuenta.seleccionado = true);
    }
  }
}
